// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { StartLinkAuthLinkTelegramStartPostMutationResponse, StartLinkAuthLinkTelegramStartPost401, StartLinkAuthLinkTelegramStartPost409, StartLinkAuthLinkTelegramStartPost429 } from "../models/accountLinkingController/StartLinkAuthLinkTelegramStartPost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getStartLinkAuthLinkTelegramStartPostUrl() {
  const res = { method: 'POST', url: `/auth/link/telegram/start` as const }
  return res
}

/**
 * @description Start Telegram account linking flow.
 * Generates a link token and returns bot URL with deep link.
 * User should open the bot URL to complete linking.
 * @summary Start Link
 * {@link /auth/link/telegram/start}
 */
export async function startLinkAuthLinkTelegramStartPost(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StartLinkAuthLinkTelegramStartPostMutationResponse, ResponseErrorConfig<StartLinkAuthLinkTelegramStartPost401 | StartLinkAuthLinkTelegramStartPost409 | StartLinkAuthLinkTelegramStartPost429>, unknown>({ method : "POST", url : getStartLinkAuthLinkTelegramStartPostUrl().url.toString(), ... requestConfig })
  return res.data
}